/**
 *  预览弹出框
 * 
 */
"use strict";
angular.module("createDepartmentManuModule", []).controller("createDepartmentManuController", ["$scope","$stateParams","transParams","$validation","$modalInstance", "trsHttpService", "$q", 'modalDialog', 'trsspliceString',
  function($scope,$stateParams, transParams,$validation,$modalInstance, trsHttpService, $q, modalDialog, trsspliceString) {
      initStatus();
      initData();
      /**
       * [initStatus description]
       * @return {[type]} [description]
       */
      function initStatus() {
          $scope.status={
              type:transParams.type,
              operation: transParams.type == 'create' ? '新建' : '编辑',
              item:transParams.item,
              departmentType:"部门",
              parentid:$stateParams.parentid,
          };
          /**
           * [saveDepartParams description] 新建或编辑部门
           * @return {[type]} [description]
           */
          $scope.saveDepartParams={
              serviceid: "mlf_departdoc",
              methodname: "saveDepart",
              DepartmentaldocId: 0,
              DepartName:'',
              DepartDesc:'',
              ParentId:$scope.status.parentid
          };
      }

      /**
       * [initData description]
       * @return {[type]} [description]
       */
      function initData() {
          if($scope.status.type=='edit'){
              $scope.companyName=$scope.status.item.DEPARTNAME;
              $scope.companyDesc=$scope.status.item.DEPARTDESC;
          }
      }
      /**
       * [confirm description] 提交
       * @return {[type]} [description]
       */
      $scope.confirm = function() {
          $scope.createDepartmentManu.$pending = {};
          $validation.validate($scope.createDepartmentManu).success(function(){
              if($scope.status.type=='edit'){
                  $scope.saveDepartParams.DepartmentaldocId=$scope.status.item.DEPARTMENTALDOCID;
              };
              $scope.saveDepartParams.DepartName=$scope.companyName;
              $scope.saveDepartParams.DepartDesc=$scope.companyDesc;
              trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.saveDepartParams, "get").then(function(data) {
                  if(data.ISSUCCESS=='true'){
                      modalDialog.alertType($scope.status.operation+'成功', '', 'success', false, function() {
                          $modalInstance.close('success');
                      });
                  }
              });
          }).error(function(){
              return;
          });
      };
      /**
       * [cancel description] 取消
       * @return {[type]} [description]
       */
      $scope.cancel = function() {
          $modalInstance.close('fail');
      };
  }
]);
